import { type FC } from 'react'
import { UpsellBodyLayout } from '../../Common/UpsellBodyLayout'
import { UpsellFeatureItem } from '../../Common/UpsellFeatureItem'
import FormTemplatePromo from '../../../../assets/images/promo-form-template.png'

import './FormTemplateUpsell.scss'

export const FormTemplateUpsellBody: FC = () => {
  return (
    <UpsellBodyLayout
      image={<img src={FormTemplatePromo} alt='Document Fill promo' className='zocks-border-0.5 form-template-upsell-promo' />}
      heading='Skip manual document filling'
      description='Upload your branded PDF templates and Zocks automatically fills and exports them.'
    />
  )
}

export const FormTemplateUpsellFeatures: FC = () => {
  return (
    <>
      <UpsellFeatureItem title='Instant form documents' description='Create filled and branded form documents in seconds for any client.' />
      <UpsellFeatureItem title='AI-powered document filling' description='Automatically populate PDF templates with client data.' />
      <UpsellFeatureItem title='Custom field mapping' description='Configure which form fields go into each document template.' className='mb-3' />
    </>
  )
}
